import {MuWidget} from "mu-widget/lib/MuWidget";
import {getSelectedValue, setSelectedValue} from "../Utils";

export class UiDateTimeRange extends MuWidget {
	beforeIndex() {
		this.muAppendContent(`
			<label>
				<input type="radio" mu-name="type" mu-id="typeNone" value="none" />
				Neomezeno
			</label>
			<label>
				<input type="radio" mu-name="type" mu-id="typePrev" value="prev" />
				Předchozích <input type="number" class="form-control display-inline-block w5em" mu-bind="daysNext" mu-id="daysNext" /> dnů.
			</label>
			<label>
				<input type="radio" mu-name="type" mu-id="typeNext" value="next" />
				Následujících <input type="number" class="form-control display-inline-block w5em" mu-bind="daysNext" mu-id="daysNext" style="width: 5em" /> dnů.
			</label>
			<label>
				<input type="radio" mu-name="type" mu-id="typeRange" value="range" />
				Od <input type="date" mu-id="rangeFrom" mu-bind="rangeFrom" class="form-control display-inline-block w8em">
				do <input type="date" mu-id="rangeTo" mu-bind="rangeTo" class="form-control display-inline-block w8em">
			</label>
		`);
	}

	muFetchData(): any {
		const data = super.muFetchData();
		data.type = getSelectedValue(this.ui.typeNone);

		return data;
	}

	muBindData(src: any): void {
		super.muBindData(src);
		setSelectedValue(this.ui.typeNone, src.type);
	}

}